/**
 * Health API Service
 * 
 * Backend Health Check
 * 
 * Endpoints:
 * GET /health - Health Check
 */

import { get } from '../client';

/**
 * Health Check - Prüft ob Backend erreichbar ist
 * @returns {Promise<{success: boolean, data?: {}, error?: object}>}
 */
export const check = async () => {
  return get('/health');
};

/**
 * Prüft ob Backend verfügbar ist
 * @returns {Promise<boolean>}
 */
export const isAvailable = async () => {
  try {
    const result = await check();
    return result.success;
  } catch {
    return false;
  }
};

/**
 * Health Check mit Timeout
 * @param {number} timeoutMs - Timeout in Millisekunden
 * @returns {Promise<boolean>}
 */
export const isAvailableWithTimeout = async (timeoutMs = 5000) => {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
    
    const result = await check();
    clearTimeout(timeoutId);
    
    return result.success;
  } catch {
    return false;
  }
};
